// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isGetFeatureFlagRolloutsDataResponse = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      app_group_id: string,
      audience_description_hash: objectOf({
        apps: arrayOf(string),
        filters: arrayOf(string),
        segments: arrayOf(string),
      }),
      can_be_copied_across_app_groups: boolean,
      core_rollout: objectOf({
        feature_flag_description: string,
        feature_flag_enabled: boolean,
        feature_flag_id: string,
        feature_flag_name: string,
        feature_flag_properties: string,
        feature_flag_send_percentage: number,
        rollout_id: string,
        rollout_nst: string,
      }),
      created: objectOf({
        d_id: string,
        name: string,
        time: number,
      }),
      created_by: string,
      filters: arrayOf(string),
      id: string,
      is_archived: boolean,
      last_edit: objectOf({
        d_id: string,
        name: string,
        time: number,
      }),
      last_edited: string,
      last_edited_by_id: string,
      migrated_created_at: number,
      segments_data_array: arrayOf(
        arrayOf(
          objectOf({
            id: string,
            name: string,
            app_group_id: string,
            is_archived: boolean,
            is_global_control: boolean,
          })
        )
      ),
      tag_names: arrayOf(string),
    })
  ),
});
